import { LOWER_JAW_QUARTILE, Quartiles } from '../config/toothConfig';

export const isLowerJaw = (quartile: Quartiles) =>
  LOWER_JAW_QUARTILE.includes(quartile);
